import {CommonService} from "./common/commonService";
import { ServicesConfig } from "./servicesConfig";

export class RoleService {

    static getRolMap = (mapId) => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/sgvmap/rolmap/" + mapId)
    )

    static getRolUser = (userName) => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/sgvmap/roluser/" + userName)
    )

    static getRoles = () => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/sgvmap/roles")
    )
}